<template>
  <div id="pageManagementWrapper">
    <div class="field">
      <input id="switchColorSuccess" type="checkbox" name="switchColorSuccess" class="switch is-success" checked="checked" v-model="isActive">
      <label for="switchColorSuccess">Pagina {{ isActive ? 'openbaar' : 'verborgen' }}</label>
    </div>

    <p class="is-size-7">
      Publieke link: {{ publicUrl }}

      <button
        id="copy"
        type="button"
        class="button"
        :class="{ 'is-success': copy }"
        v-clipboard:copy="publicUrl"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError">

        <span class="icon">
          <i v-if="copy" class="fas fa-check"></i>
          <i v-if="!copy" class="fas fa-clipboard"></i>
        </span>
      </button>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageManagement',
  data () {
    return {
      copy: null
    }
  },
  computed: {
    ...mapGetters({
      page: 'pages/page'
    }),
    publicUrl () {
      return `${process.env.VUE_APP_API}/#/publieke-content/${this.page.code}`
    },
    isActive: {
      get () {
        return (this.page) ? this.page.is_active : false
      },
      set () {
        this.$store.dispatch('pages/toggle', {
          page_id: this.page.id,
          bundle_id: this.page.bundle.id
        })
      }
    }
  },
  methods: {
    onCopy () {
      this.copy = true
    },
    onError () {
      this.copy = false
    }
  }
}
</script>

<style scoped>
  #copy {
    top: -10px;
    margin: 0 0 0 15px;
  }
</style>
